import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { useTheme } from "./util/themes";
import { ThemeWrapper } from "./components/providers/ThemeWrapper";
import { ShippingProvider } from "@ecommerce/checkout";

import DefaultLayout from "./layouts/DefaultLayout";

import Home from "./pages/Home";
import ProductosPage from "./pages/ProductosPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import SearchResultsPage from "./pages/SearchResultsPage";
import ProductListing from "./components/ProductListing";

import ScrollToTop from "./components/ScrollToTop";

import { ErrorBoundary } from "react-error-boundary";
import { AppErrorFallback } from "./components/errors/AppErrorFallback";
import { HttpLogger } from "./http";

import { SecurityObjectProvider } from "./security/SecurityObjectProvider";
import { ProductCategoryProvider } from "@/contexts/ProductCategoryContext";
import { UserDataProvider } from "@/contexts/UserDataContext";
import { TiendaInfoProvider } from "@/contexts/TiendaInfoContext";

function App() {
    const theme = useTheme();

    useEffect(() => {
        document.documentElement.style.backgroundColor = theme.colors.background.default;
        document.documentElement.style.color = theme.colors.text.primary;
        document.body.style.backgroundColor = theme.colors.background.default;
        document.body.style.color = theme.colors.text.primary;
        document.body.style.fontFamily = theme.typography.fontFamily.primary;
    }, [theme]);

    const handleReactError = (error: Error, info: React.ErrorInfo) => {
        HttpLogger.logReactError({
            app: "FrontTienda",
            environment: (window as any).APP_ENV ?? "prod",
            release: (window as any).APP_VERSION ?? undefined,

            url: window.location.href,
            path: window.location.pathname + window.location.search,
            userAgent: navigator.userAgent,
            timestampUtc: new Date().toISOString(),

            errorName: error.name,
            errorMessage: error.message,
            errorStack: error.stack ?? null,
            componentStack: info?.componentStack ?? null,

            extra: {},
        });
    };

    return (
        <ThemeWrapper>
            <TiendaInfoProvider>
            <ErrorBoundary
                FallbackComponent={AppErrorFallback}
                onError={handleReactError}
            >
                <SecurityObjectProvider>
                    <ShippingProvider>
                        <UserDataProvider>
                            <ProductCategoryProvider>
                                <Router>
                                    <ScrollToTop />
                                    <Routes>
                                        <Route path="/" element={<DefaultLayout />}>
                                            <Route index element={<Home />} />
                                            <Route path="productos" element={<ProductosPage />} />
                                            <Route path="productos/:sku" element={<ProductDetailPage />} />
                                            <Route path="categoria/:sku" element={<ProductListing mode="category" />} />
                                            <Route path="/search" element={<SearchResultsPage />} />
                                        </Route>
                                    </Routes>
                                </Router>
                            </ProductCategoryProvider>
                        </UserDataProvider>
                    </ShippingProvider>
                </SecurityObjectProvider>
            </ErrorBoundary>
            </TiendaInfoProvider>
        </ThemeWrapper>
    );
}

export default App;
